import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './styles.css'

class StoryCarousel extends Component {
  static propTypes = {
    className: PropTypes.string,
    stories: PropTypes.arrayOf(
      PropTypes.shape({
        picture: PropTypes.string.isRequired,
        story: PropTypes.node.isRequired,
      }),
    ).isRequired,
    frequence: PropTypes.number,
  }

  static defaultProps = {
    className: '',
    frequence: 20000,
  }

  constructor(props) {
    super(props)
    this.state = {
      active: Math.floor(props.stories.length / 2),
    }
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      this.setState((prevState, props) => ({
        active: (prevState.active + 1) % props.stories.length,
      }))
    }, this.props.frequence)
  }

  componentWillReceiveProps() {
    this.setState({ active: 0 })
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  getClassName() {
    return classnames(styles.root, this.props.className)
  }

  render() {
    const {
      className,
      stories,

      ...restProps
    } = this.props
    const { active } = this.state

    return (
      <div className={this.getClassName()} {...restProps}>
        <div className={styles.bubble}>
          {stories.map(({ story }, index) => (
            // Render all stories and hide the non-active ones with
            // CSS so that all of the Djedi nodes always appear in
            // the Djedi sidebar.
            <blockquote
              key={index}
              className={styles.quote}
              hidden={index !== active}
            >
              {story}
            </blockquote>
          ))}
        </div>
        <div className={styles.heads}>
          {stories.map(({ picture }, i) => (
            <div
              className={classnames(styles.head, {
                [styles.active]: active === i,
              })}
              key={i}
              onClick={() => {
                clearInterval(this.timer)
                this.setState({ active: i })
              }}
              role="radio"
            >
              <div
                className={classnames(styles.triangle, {
                  [styles.hidden]: active !== i,
                })}
              />
              <div className={styles.pictureWrapper}>
                <img src={picture} alt="" className={styles.picture} />
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default StoryCarousel



// WEBPACK FOOTER //
// ../source/components/StoryCarousel/index.js